var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"usePowerUnitBody custom-scrollbar"},[_c('unitInfo',{staticClass:"marginRight smallWindow"}),_c('workStateNoWork',{staticClass:"smallWindow"}),_c('deviceLine',{staticClass:"bigWindow marginTop"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }